import React, { FC, memo, useCallback, MouseEvent } from 'react';
import { openItemModal, openCategoryModal } from 'data/cacheHelpers/menu';
import { Draggable } from 'react-beautiful-dnd';
import {
  Container,
  Header,
  NameCategory,
  Button,
  ArrowUp,
  ArrowDown,
  Content,
  Section,
  DraggableIcon,
} from './styles';
import Items from './Items';
import useConnect from './connect';
import { Props } from './types';

const Category: FC<Props> = ({
  index,
  brandId,
  id,
  name,
  items,
  itemsMap,
  isProcessing,
  allowAddItem,
}) => {
  const { hide, toggleDropdown } = useConnect();

  const openNewItem = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      openItemModal({
        brandId,
        item: {
          categoryId: id,
          childrenEntities: [],
        },
      });
    },
    [brandId, id],
  );

  const openEditCategoryModal = useCallback(
    (event: MouseEvent<HTMLParagraphElement>) => {
      event.stopPropagation();
      openCategoryModal(brandId, { id, name });
    },
    [brandId, id, name],
  );

  return (
    <Draggable draggableId={id} index={index} isDragDisabled={isProcessing}>
      {(provided) => (
        <Container
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <Header onClick={toggleDropdown}>
            {!isProcessing && <DraggableIcon />}
            <NameCategory onClick={openEditCategoryModal}>{name}</NameCategory>
            <Section>
              {!hide && allowAddItem ? (
                <Button onClick={openNewItem}>Add Item</Button>
              ) : null}
              {!hide ? <ArrowDown /> : <ArrowUp />}
            </Section>
          </Header>

          {!hide && (
            <>
              <Content>
                <Items
                  brandId={brandId}
                  categoryId={id}
                  items={items}
                  itemsMap={itemsMap}
                  isProcessing={isProcessing}
                />
              </Content>
            </>
          )}
        </Container>
      )}
    </Draggable>
  );
};

export default memo(Category);
